
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("9FkkO", function(module, exports) {
"use strict";
var $7097b76cf0a61149$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ShareFat = void 0;

const $7097b76cf0a61149$var$react_1 = $7097b76cf0a61149$var$__importDefault((parcelRequire("acw62")));
const $7097b76cf0a61149$var$ShareFat = ({ fill: fill = "none" })=>{
    if (fill === "filled") return $7097b76cf0a61149$var$react_1.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%"
    }, $7097b76cf0a61149$var$react_1.default.createElement("path", {
        fill: "currentColor",
        d: "M237.66,117.66l-80,80A8,8,0,0,1,144,192V152.23c-57.1,3.24-96.25,40.27-107.24,52h0a12,12,0,0,1-20.68-9.58c3.71-32.26,21.38-63.29,49.76-87.37,23.57-20,52.22-32.69,78.16-34.91V32a8,8,0,0,1,13.66-5.66l80,80A8,8,0,0,1,237.66,117.66Z"
    }));
    return $7097b76cf0a61149$var$react_1.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 32 32",
        fill: "none",
        "aria-hidden": true
    }, $7097b76cf0a61149$var$react_1.default.createElement("path", {
        d: "M5 29.0164C4.45 29.0164 4 28.5664 4 28.0164C4 24.833 4 20.4664 5.7 16.7497C7.66667 12.4497 11.4333 10.1664 16.9 9.91637V5.79971C16.9 5.39971 17.15 5.03304 17.5167 4.88304C17.8833 4.73304 18.3167 4.81637 18.6 5.09971L28.8 15.2997C29.1833 15.683 29.1833 16.3164 28.8 16.7164L18.6 26.9164C18.3167 27.1997 17.8833 27.283 17.5167 27.133C17.15 26.983 16.9 26.6164 16.9 26.2164V22.133C6.28333 22.433 6 27.7497 6 28.0164C6 28.5664 5.55 29.0164 5 29.0164ZM17.9 20.0997C18.45 20.0997 18.9 20.5497 18.9 21.0997V23.783L26.6833 15.9997L18.9 8.21637V10.8997C18.9 11.4497 18.45 11.8997 17.9 11.8997C12.6667 11.8997 9.26667 13.7497 7.51667 17.5664C6.65 19.433 6.28333 21.5664 6.11667 23.6164C8.5 21.283 12.45 20.0997 17.9 20.0997Z",
        fill: "currentColor"
    }));
};
module.exports.ShareFat = $7097b76cf0a61149$var$ShareFat;

});


//# sourceMappingURL=share-fat.fe90c66a.js.map
